const styles = {
  registeredButton: {
    width: "130px",
  },
  searchBox: {
    display: "flex",
    width: "20%",
    marginLeft: "auto",
    marginBottom: "1em",
    marginRight: "1em",
  },
  tableToolBar: {
    marginLeft: "2em",
    marginBottom: "1em",
  },
  title: {
    fontWeight: "bold",
    marginBottom: "0.5em",
    paddingTop: "1em",
  },
  table: {
    fontSize: 16,
    height: "65vh",
  },
  dropdown: {
    width: "120px",
    margin: "0.5%",
  },
  selection: {
    maxHeight: 148,
    overflowY: "scroll",
  },
  searchArea: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
};

export default styles;
